import TasksCustomFieldsLookup from "../../../model2/project/inheritance/task-custom-fields"
import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {CustomFieldAccess, CustomFieldScope} from "../../../model2/custom-field/@const";
import DebugPerformance from "../../utils/performance";


// const debug = "getProjectTaskListCustomFields"
const debug = false

export default function getProjectTaskListCustomFields(taskTypeIds?:ID[], projectId?:ID, scope?:CustomFieldScope[]):SessionCustomField[] {

    debug && console.log(debug, "getProjectTaskListCustomFields() taskTypeIds=",taskTypeIds, "projectId=",projectId, "scope=", scope);

    // task Types passed can be different from all project task types i.e. we moved a task type v proekt
    // which doesnt have this task type in settings

    let customFields    : SessionCustomField[] = [];
    let customFieldsIds : ID[]  = [];

    /*// find all parent and child projects to create ultimates project Ids array
    let allProjectsIds = [projectId];
    allProjectsIds = _.concat(allProjectsIds, gd.tree.findProjectParents(gd.tree.getProject(projectId)).map(p=>p.id));
    allProjectsIds = _.concat(allProjectsIds, gd.tree.findProjectChildren(projectId).map(p=>p.id));
    // console.log("So all projects=", allProjectsIds);

    // get custom fields from all projects
    allProjectsIds.map(projectId=>{
        const project = gd.session.projects.get(projectId);
        if (project && project.customFields) customFieldsIds = _.concat(customFieldsIds, project.customFields);
    });*/

    const project = gd.session.projects.get(projectId)

    // get custom fields from all projects (parents and children)
    customFieldsIds = project ? new TasksCustomFieldsLookup(project.id).getAll() : []

    // find all task types for the current project Only ( mi ignore case kogda sub folder has more task types )
    const projectTaskTypesIds = project ? project!.getInheritedTaskTypes() : []

    // union passed task types and project task types
    const allTaskTypeIds = _.union(taskTypeIds, projectTaskTypesIds);

    // add custom fields from all task types
    allTaskTypeIds.map(taskTypeId => {
        const taskType = gd.session.taskTypes.get(taskTypeId);
        if (taskType) customFieldsIds = _.concat(customFieldsIds, taskType.customFields);
    });

    // find unique only
    customFieldsIds = _.uniq(customFieldsIds);

    // create CF objects array
    customFieldsIds.map(customFieldId => {
        const customField = gd.session.customFields.get(customFieldId)!
        if (customField && (!scope || _.intersection(customField.params.scope, scope).length > 0)) customFields.push(customField);
    });

    const isManager = gd.ac.check.company.isManager(gd.companyId);
    // If not full access in project - delete CF current user should not see
    // if (!isManager) customFields = _.filter(customFields, (cf) => cf.access === gd.const.customFields.access.EVERYONE);
    if (!isManager) customFields = _.filter(customFields, (cf) => cf.access === CustomFieldAccess.EVERYONE);

    debug && console.log(debug, "  result = ",customFields);

    return customFields;
}